import { Component, Input, OnInit } from '@angular/core';

import { AppFontSize } from 'src/app/core/types/app-font-size.type';
import { AppTdValue } from 'src/app/core/types/app-td-value.type';
import { TranslationService } from '../../../i18n/translation.service';

@Component({
    selector: 'td-value',
    templateUrl: './td-value.component.html',
    standalone: false
})
export class TdValueComponent implements OnInit {
  @Input() value: string | number | boolean;
  @Input() type: AppTdValue = 'text';
  @Input() fontSize: AppFontSize = 'sm';
  @Input() hasNumberSeparator: boolean = false;

  constructor(public translationService: TranslationService) {}

  ngOnInit() {}
}
